import React from 'react';
import deities1 from '../assets/images/deities/deities1.jpg';
import deities2 from '../assets/images/deities/deities2.jpg';
import deities3 from '../assets/images/deities/deities3.jpeg';
import deities4 from '../assets/images/deities/deities4.jpg';
import deities5 from '../assets/images/deities/deities5.jpeg';
import './Goshala.css';

function Deities() {
    return (
        <section className="goshala-section">
            <div className="container">
                <br />
                <h1 className="goshala-title text-center">ISKCON Deities Dress</h1>
                <h2 className="text-center">
                    yadi papi chadi dharma dure dese yaya <br />
                    mora senapati-bhakta yaibe tathaya
                </h2>
                <br />

                <p>
                    ISKCON Ujjain makes beautiful Srila Prabhupada Deity / Murti and Guru Parampara Deity / Murti with the Vyasasan in many different sizes.
                    We use the original moulds to make the Deity / Murti which have been made by Srila Prabhupada’s disciple His Grace Lochan Prabhu.
                    Get (Buy Online) the Deity / Murti of Srila Prabhupada for your House and Temple. A complete range of Srila Prabhupada Deity / Murti from 4 inches to life-sized.
                    We deliver Online Deity / Murti to ISKCON Communities throughout the whole world:
                    United States (California), Canada, Australia, London, Europe, Russia, South Africa (Durban, Pietermaritzburg), Germany, Switzerland, Dubai, Singapore, Malaysia, El Dorado Hills,
                    and across India: Ekachakra, Durgapur, Pandharpur, Panihati, Madurai, Kolkata, Bengaluru, Mumbai, Delhi.
                    <br /><br />
                    Deity / Murti are available in these sizes:
                </p>

                <ul>
                    <li> 4″ Srila Prabhupada Deity / Murti</li>
                    <li> 6.5″ Srila Prabhupada Deity / Murti</li>
                    <li> 12″ Srila Prabhupada Deity / Murti</li>
                    <li> 12″ Srila Bhaktisiddhanta Sarasvati Deity / Murti</li>
                    <li> 18″ Srila Prabhupada Deity / Murti</li>
                    <li> 30″ (Life Size) Srila Prabhupada Deity / Murti</li>
                    <li> 30″ (Life Size) Srila Prabhupada Deity / Murti (Writing Pose)</li>
                    <li> 6.5″ Guru Parampara Deity / Murti with Vyasasan (Srila Prabhupada, Srila Bhaktisiddhanta Sarasvati, Srila Gaurakisora Dasa Babaji, Srila Bhaktivinoda Thakur, Srila Jagannatha Dasa Babaji)</li>
                    <li> Other Wooden Items like Altars, Simhasanas, Vyasasanas, Donation Boxes, and Tables for Tulasi Maharani</li>
                </ul>
            </div>

            <div className="gallery-grid">
                <img src={deities1} alt="Srila Prabhupada deity with garland" />
                <img src={deities2} alt="Closeup of Srila Prabhupada murti" />
                <img src={deities3} alt="Srila Prabhupada deity on Vyasasana" />
                <img src={deities4} alt="Decorated Guru Parampara murtis" />
                <img src={deities5} alt="Deity altar with offerings" />
            </div>
        </section>
    );
}

export default Deities;
